/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const CustomerPerformanceService = {
  async getYtd(customerCode) {
    return await ApiService.get(
      `api/CustomerPerformance/${encodeURIComponent(customerCode)}`
    );
  },

  async getMonthly(customerCode) {
    return await ApiService.get(
      `api/CustomerPerformance/${encodeURIComponent(customerCode)}/Monthly`
    );
  },
};

export { CustomerPerformanceService };
